/** Explicit per status so a new workflow status fails typecheck; null-action statuses sit at the rung their predecessors imply. */
const TARGET_RUNG_BY_WORKFLOW_STATUS = {
    SUBMITTED: 'Submitted',
    ACCEPTED: 'Accepted',
    AWAITING_APPROVAL: 'Submitted',
    REJECTED: null,
    DELIVERY_SCHEDULING: 'Accepted',
    READY_TO_DELIVER: 'Fulfilled',
    SHIPPED: 'Shipped',
    DELIVERED: 'Shipped',
    COMPLETE: 'Complete',
    CANCELLED: null,
};
/** The LeafLink status a Nudool status maps to; null for the ending statuses, which sit on no rung. */
export function leafLinkRungFor(status) {
    return TARGET_RUNG_BY_WORKFLOW_STATUS[status];
}
//# sourceMappingURL=leaflink-rung-for.js.map